/**
 * stripMarkdown — cheap, regex-based markdown → plain-text converter.
 *
 * Used for the browser-notification `body` so the OS chrome doesn't
 * render literal asterisks, brackets, and backticks. NOT a full parser
 * — strikethrough, bold, italic, inline code, fenced code, links,
 * headings, and list bullets cover ≥99% of chat-message markdown.
 *
 * Anything more exotic (tables, images, blockquotes, HTML) passes
 * through with the markup intact; the browser notification still
 * renders, just slightly noisier.
 */

export function stripMarkdown(input: string): string {
  return input
    .replace(/```[\s\S]*?```/g, '[code]')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/~~([^~]+)~~/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/^[-*+]\s+/gm, '')
    .replace(/^\d+\.\s+/gm, '')
    .trim()
}
